<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="container-small-table">
      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllLogs.data"
            height="calc(100vh - 200px)"
            @sort-change="onChangeSort"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
          >
            <el-table-column
              prop="description"
              label="DESCRIPTION"
              width="360"
              sortable="custom"
            >
              <template #default="scope">
                <span class="error-break">{{ scope.row.description  || "--"}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reason"
              label="REASON"
              width="230"
              sortable="custom"
            >
              <template #default="scope">
                <span class="error-break">{{ scope.row.reason  || "--"}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="ORDERING FACILITY"
              prop="hospital_id"
              width="200"
              sortable="custom"
            >
              <template #default="scope">
                {{ scope.row.hospital_id ? scope.row.hospital_id.name : "--" }}
              </template>
            </el-table-column>
            <el-table-column
              label="Physician"
              prop="physician_id"
              width="150"
              sortable="custom"
            >
              <template #default="scope">
                {{
                  scope.row.physician_id ? scope.row.physician_id.name : "--"
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="USER"
              sortable="custom"
              prop="user"
              width="150"
            >
              <template #default="scope">
                {{
                  scope.row.user
                    ? scope.row.user.first_name + " " + scope.row.user.last_name
                    : "--"
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              sortable="custom"
              width="130"
              prop="created_at"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") || "--"}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="130">
              <template #default="scope">
                <el-button
                  v-if="
                    scope.row.changed_data && scope.row.changed_data.length > 0
                  "
                  class="btn small-add-test-btn"
                  style="border: none"
                  @click="showDetails(scope.row.changed_data)"
                >
                  Show Details
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout="prev, pager, next, jumper, sizes, total"
              :total="getAllLogs.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="default-modal blue-background">
      <el-dialog v-model="dialogVisible" width="60%">
        <div class="dialog-header">
          <span class="header-part"> Changed Details </span>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table :data="selectedDetails" style="width: 100%">
                  <el-table-column prop="key" label="Field Name">
                    <template #default="{ row }">
                      {{ formatKey(row.key) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="previous_value"
                    label="Initial Data"
                  />
                  <el-table-column prop="present_value" label="Updated Data" />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn">
          <el-button @click="dialogVisible = false">Close</el-button>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
export default {
  name: "",
  components: {},
  mixins: [UserPermissionsHelper, FilterHelper],
  data() {
    return {
      page: 1,
      pageSize: 25,
      loading: false,
      orderBy: "",
      orderType: "",
      logsTable: {},
      orderLogs: {},
      searchCaseLoading: false,
      allOrders: [],
      searchOrderId: "",
      search_string: "",
      selectedDetails: [],
      dialogVisible: false,
    };
  },
  computed: {
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("logs", ["getAllLogs"]),
    ...mapGetters("cases", ["getAllCases"]),
    ...mapGetters("orders", [
      "getAllOrders",
      "getCaseDeleteStatus",
      "getCaseDeleteError",
    ]),
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchAllLogs();
    this.logsTable = JSON.parse(JSON.stringify(this.getAllLogs));
  },
  methods: {
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async querySpuAttrNames(query) {
      if (query.length >= 3) {
        this.searchCaseLoading = true;
        let params = {
          search_string: query,
          get_all: true,
          status: caseConstants.ORDER_STATUSES,
        };
        await this.$store.dispatch("orders/getOrders", params);
        this.allOrders = this.getAllOrders.data;
        this.searchCaseLoading = false;
      }
    },
    getAuditlogsByOrder() {
      this.getAutoCompleteOrdersData();
    },
    async clearAuditLogsSearch() {
      this.searchOrderId = "";
      await this.fetchAllLogs(1);
    },
    async getAutoCompleteOrdersData() {
      this.previousSearchString = this.search_string;

      this.page = 1;
      this.loading = true;
      let params = { page: this.page, type: "GENERAL" };

      if (this.searchOrderId) {
        params.order_id = this.searchOrderId;
      }

      if (!this.isBillingUser) {
        params.audit_section = "BILLING";
      }
      if (this.isBillingUser) {
        params.audit_section = "TESTING";
      }

      await this.$store.dispatch("logs/fetchAllLogs", params);

      if (
        !this.search_string ||
        this.getAllLogs.search_string === this.search_string
      ) {
        this.logsTable = JSON.parse(JSON.stringify(this.getAllLogs));
      }
      this.loading = false;
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllLogs();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllLogs();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllLogs();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        type: "GENERAL",
      };
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }

      if (!this.isBillingUser) {
        params.audit_section = "BILLING";
      }
      if (this.isBillingUser) {
        params.audit_section = "TESTING";
      }
      return params;
    },
    async fetchAllLogs() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("logs/fetchAllLogs", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    goToViewOrders() {
      this.$router.push({
        path: "/emr-orders/view",
      });
    },
    showDetails(data) {
      this.dialogVisible = true;
      this.selectedDetails = data;
    },
    formatKey(key) {
      return key
        .replace(/_/g, " ")
        .replace(/\./g, " - ")
        .replace(/^\w/, (c) => c.toUpperCase());
    },
  },
};
</script>

<style lang="scss">
.image-fluid {
  width: 100%;
}
.close-btn {
  text-align: end;
  padding: 0 1rem 0.5rem;
  .el-button {
    min-height: 30px;
    padding: 0 1.3rem;
    color: #ffffff;
    background-color: #eb5757;
    border-radius: 7px;
    border: none;
    &:hover,
    &:focus {
      background-color: #eb5757;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
